import { Directive, Input, OnInit } from '@angular/core';
import { ZippyOpenDirective } from '@df/legacy/ui/zippy/zippy-open.directive';

@Directive({ standalone: false, selector: '[zippyToggle]' })
export class ZippyToggleDirective extends ZippyOpenDirective implements OnInit {
    /**
     * Zippy name setter
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     */
    @Input() set zippyToggle(name: string | (string | number)[]) {
        this.parseName(name);
    }

    /**
     * Click event listener
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     * @param  {[type]} 'click'
     */
    override onClick(): void {
        if (!this.client.isCms) {
            this.toggle();
        } else {
            if (!this.clicks) {
                this.timeoutService.setTimeout(
                    () => {
                        if (this.clicks === 1) {
                            if (this.client.isCms || this.isOnClick) {
                                this.toggle();
                            }
                        }

                        this.clicks = 0;
                    },
                    this.client.isCms ? 300 : 0
                );
            }

            this.clicks++;
        }
    }
}
